// factory function, not to be confused with batws.js which is not (see module.fad.js)
import RestAPI from 'lib/rest';

var spec = {
  host: '/offers-service',
  apis: {
    offers: {
      url: '/v1/marketing/',
      calls: {
        all: {
          url: 'offers/{zipCode}/',
          dataType: 'json',
          defaults: {
            pageSize: 9,
            startIndex: 0,
            lang: 'en'
          }
        },

        // document the reqs here
        byOfferId: {
          url: 'offers/{zipCode}/',
          dataType: 'json',
          defaults: {
            offerId: null,
            lang: 'en',
          }
        }
      }
    }
  }
};

export default function (apiKey) {
  return new RestAPI(spec, { params: { clientId: apiKey } });
};
